<template lang="pug">
.conteudo
    .linha(style='margin: 0px')
        .coluna
            title-component(
                label='Regiões de Análise'
            )

    .linha(style='marginTop: 0px')
        .coluna
            breadcrumb-component(:list='regiaoAnalise')

    .linha
        .coluna
            filter-basic-component(
                @filtro:pesquisar='pesquisar({nome: $event, pagina: 1, quantidadePagina: 10})', 
            )
        .coluna-2.cadastro-position
            button-component.botao-cadastrar(
                style="width: '100%'"
                label='Cadastrar nova região',
                icon='mdi-plus-circle-outline',
                @click.native='cadastrar()',
            )

    .linha
        .coluna
            regiao-analise-table(
                :headers='headers',
                :data='paginacao.regioes',
                :paginacao='paginacao',
                :is-loading='isLoading',
                @inbox:page-change='checkPaginationChange($event)',
                @inbox:pagination='getPagination($event)'
            )
</template>

<script>
import {
    listar,
} from '@/services/regiaoAnalise.service';

import FilterBasicComponent from '@/components/standard/FilterBasicComponent.vue';
import RegiaoAnaliseTable from '@/views/regiaoAnalise/components/RegiaoAnaliseTable.vue';

import { regiaoAnalise } from '@/utils/breadcrumb.utils';

export default {
    name: 'RegiaoAnaliseComponent',
    components: {
        FilterBasicComponent,
        RegiaoAnaliseTable
    },
    data() {
        return {
            headers: [
                {
                    text: 'Nome da região',
                    field: 'nome',
                    maxWidth: ''
                },
                {
                    text: 'Data de cadastro',
                    field: 'dataCadastro',
                    maxWidth: '70px'
                },
                {
                    text: 'Total de municípios',
                    field: 'quantidadeMunicipios',
                    maxWidth: '70px'
                },
                {
                    text: 'Ações',
                    field: 'acao',
                    maxWidth: ''
                },
            ],
            paginacao: {
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                regioes: [],
            },
            regiaoAnalise: regiaoAnalise.listagem,
            isLoading: false
        };
    },

    created() {
        this.isLoading = true;
        Promise.all([
            this.pesquisar({
                pagina: 1,
                quantidadePagina: 10,
            }),
        ]).then(() => {
            this.isLoading = false;
        });
    },

    methods: {
        async pesquisar(filtro) {
            this.filtro = filtro;
            this.isLoading = true;
            this.paginacao = await listar(filtro);
            this.paginacao.regioes.forEach(function (regiao, index) {
                regiao.acao = [
                    {
                        id: 'VINCULAR_GO',
                        label: 'Vincular/Desvincular gerente operacional',
                        icon: 'mdi-link-variant'
                    },
                    {
                        id: 'EDITAR',
                        label: 'Editar',
                        icon: 'mdi-note-edit-outline'
                    },
                    {
                        id: 'VISUALIZAR',
                        label: 'Visualizar',
                        icon: 'mdi-magnify'
                    },
                    {
                        id: 'EXCLUIR',
                        label: 'Excluir',
                        icon: 'mdi-trash-can-outline'
                    },
                ];
            });
            this.isLoading = false;
        },

        checkPaginationChange(event) {

            this.pesquisar(event);
        },

        getPagination(paginationEvent) {

            return paginationEvent;
        },

        cadastrar() {
            this.$router.push({ name: 'regiao-cadastrar' })
        }
    },
};
</script>

<style lang="scss" scoped>
.paginacao {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.cadastro-position {
    display: flex;
    justify-content: flex-end;
}

.botao-cadastrar {
    height: 32px;
}
</style>
